import React from "react";
import "../MathFormulaPrivacyPolicy.css";
import { useNavigate } from "react-router-dom";
import SEO from "./SEO";

const GroceryPrivacyPolicy = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/");
  };

  return (
    <div className="privacy-policy-page">
      <SEO
        title="Privacy Policy - Grocery Expenses Tracker | BlueOrbit Technologies"
        description="Privacy Policy for Grocery Expenses Tracker app. Learn how we respect your privacy and keep your data safe."
        keywords="privacy policy, data protection, Grocery Expenses Tracker app privacy, BlueOrbit Technologies privacy"
      />

      <header className="privacy-header">
        <div className="container">
          <nav className="nav">
            <div className="logo" onClick={goHome} style={{ cursor: "pointer" }}>
              <i className="fas fa-orbit"></i>
              <span>BlueOrbit Technologies</span>
            </div>
          </nav>
        </div>
      </header>

      <section className="privacy-hero">
        <div className="container">
          <h1>Privacy Policy</h1>
          <ul className="breadcrumb">
            <li><a href="/">Home</a></li>
            <li><a href="/">Apps</a></li>
            <li>Privacy Policy</li>
          </ul>
        </div>
      </section>

      <section className="privacy-content">
        <div className="container">
          <div className="privacy-header">
            <h2>Privacy Policy for Grocery Expenses Tracker App</h2>
            <p className="effective-date">Effective Date: [29-09-2025]</p>
          </div>

          <div className="policy-content">
            <div className="policy-section">
              <h3>1. Information We Collect</h3>
              <p>
                We respect your privacy. Our app does not collect or store any personal information. You can use all features of the app without sharing any personal data.
              </p>
              <ul>
                <li><strong>Non-Personal Information:</strong> Only anonymous usage data may be collected for performance improvements, but no personal data is ever stored.</li>
                <li><strong>No Sensitive Data Access:</strong> We do not access contacts, messages, or any private information from your device.</li>
              </ul>
            </div>

            <div className="policy-section">
              <h3>2. App Features</h3>
              <p>
                The Grocery Expenses Tracker app allows you to track your grocery purchases, manage your expenses, and organize your shopping lists efficiently.
              </p>
              <p>
                The app operates fully offline, ensuring your data is only stored locally on your device and never shared with any server or third party.
              </p>
            </div>

            <div className="policy-section">
              <h3>3. Data Security</h3>
              <p>
                Since we do not collect personal data, your information remains private and secure on your device. No external transmission occurs, and all features function offline.
              </p>
            </div>

            <div className="policy-section">
              <h3>4. Third-Party Services</h3>
              <p>
                Our app may use third-party libraries or services for app functionality, but these do not collect any personal information from you.
              </p>
            </div>

            <div className="policy-section">
              <h3>5. Children's Privacy</h3>
              <p>
                This app is not intended for children under 13 years of age. We do not knowingly collect information from children.
              </p>
            </div>

            <div className="policy-section">
              <h3>6. Changes to This Privacy Policy</h3>
              <p>
                We may update this Privacy Policy periodically. Changes will be posted here with the effective date. Please check this page regularly for updates.
              </p>
            </div>

            <div className="policy-section">
              <h3>7. Contact Us</h3>
              <p>
                If you have any questions about this Privacy Policy, please contact us at:
              </p>
              <p>Email: Blueorbittechnologies@gmail.com</p>
              <p>
                By using the Grocery Expenses Tracker app, you agree to this Privacy Policy.
              </p>
            </div>
          </div>
        </div>
      </section>

      <footer className="privacy-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>BlueOrbit Technologies</h3>
              <p>Creating innovative mobile solutions that make managing daily life easier.</p>
            </div>
            <div className="footer-section">
              <h3>Quick Links</h3>
              <ul>
                <li><a href="/">Home</a></li>
                <li><a href="/">Our Apps</a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 BlueOrbit Technologies. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default GroceryPrivacyPolicy;
